export const PICTO_SIZES = {
  small: 'w-12 h-12',
  base: 'w-14 h-14',
  large: 'w-16 h-16',
};

type ObjectValues<T> = T[keyof T];
export type PictoSizeType = ObjectValues<typeof PICTO_SIZES>;
